// extracted by mini-css-extract-plugin
module.exports = {"horizontalNav":"_1VUdk4hV_tK2RE7wNlaB3h","button":"hDmtbIgsbfnzH37HtNMCh","left":"_1dr8j8h4KTjKolg-YdMuE5","right":"DU3U4bwoZXf0vCtFnIlk6"};